<form [formGroup]="attendeesExportForm" *ngIf="attendeesExportForm" class="attendeesExportForm">
    <div class="w-full">
        <div class="flex flex-column">
            <div class="field w-full exportStart">
                <label for="startDate" class="text-base" i18n="@@attendee-export-forms.startDate">Export from</label>
                  <div class="flex-1">
                    <input type="date" class="p-inputtext p-component w-full" i18n-placeholder="@@attendee-export-forms.date" placeholder="Date" formControlName='startDate' 
                        [ngStyle]="{'border-top-right-radius':0,'border-bottom-right-radius':0,'height':'35px'}" >
                </div>
            </div>
            <div class="field w-full exportEnd">
                <label for="endDate" class="text-base" i18n="@@attendee-export-forms.endDate">until</label>
                  <input type="date" class="p-inputtext p-component w-full" i18n-placeholder="@@attendee-export-forms.date" placeholder="Date" formControlName='endDate'
                  [ngStyle]="{'border-top-right-radius':0,'border-bottom-right-radius':0,'height':'35px'}" >
            </div>
            <div class="flex mt-2 createWorksheet">
                <div>
                    <p-checkbox [binary]="true" formControlName='createWorksheets' ></p-checkbox>
                </div>
                <label for="createWorksheets" i18n="@@attendee-export-forms.createWorksheets" class="ml-2">Create worksheets for events</label>
            </div>
        </div>
    </div>
    <div class="text-right col-12">
        <p-button label="Export" styleClass="mt-3 mb-3" class="exportButton" [disabled]="attendeesExportForm.invalid || attendeesExportForm.pristine" (onClick)="onAccept()"
            i18n-label="@@attendee-export-forms.exportButton" severity="secondary"></p-button>
    </div>
</form>